module.exports = __webpack_public_path__ + "img/page-banner.4a40cc91.jpg";